module.exports = __webpack_public_path__ + "static/media/monlix.35dd037a.png";